import { ViewManagementStore } from 'Shared/models/ViewManagementModel';
import { ViewManagement } from '../Actions/EnumTypes/ActionEnumTypes';
// import { ViewsManagemenetAction } from '../Actions/Models/ViewManagementActionModel';

export type State = ViewManagementStore;

export const initialState: State = {
  loaderVisible: false,
};

export function viewManagementReducer(state: State = initialState, action) {
  switch (action.type) {
    case ViewManagement.SHOW_LOADER: {
      return {
        ...state,
        loaderVisible: true,
      };
    }
    case ViewManagement.HIDE_LOADER: {
      return {
        ...state,
        loaderVisible: false,
      };
    }
    default: {
      return state;
    }
  }
}
